import { render, staticRenderFns } from "./CompanyHeader.vue?vue&type=template&id=04cd0a68&scoped=true&"
import script from "./CompanyHeader.vue?vue&type=script&lang=js&"
export * from "./CompanyHeader.vue?vue&type=script&lang=js&"
import style0 from "./CompanyHeader.vue?vue&type=style&index=0&id=04cd0a68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cd0a68",
  null
  
)

export default component.exports